export enum PageFunction {
	ADD = 'add',
	EDIT = 'edit',
}
